import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CurrentUserModel } from '../../../models/account-ledger.model';
import { BulkOrderValidationResult } from '../../../models/csp.model';
import { FileService } from "../../../services/file.service";
import { ManageService } from '../../../services/manage.service'
import { CommonService } from '../../../services/common.service';
import { AuthService } from '../../../services/auth.service';
import { ApiResponse } from '../../../models/api-response.model';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-bulk-transfer',
  templateUrl: './bulk-transfer.component.html',
  styleUrls: ['./bulk-transfer.component.css']
})
export class BulkTransferComponent implements OnInit, OnDestroy {
  title = 'Bulk Transfer';
  loadContent = true;
  file: any;
  public fileName: string;
  public resultTableDataSrc: BulkOrderValidationResult[] = [];
  disableUpload: boolean;
  tooltipUpload: string;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  currentUserModel: CurrentUserModel;
  dataList: Array<number> = [];
  public validateColumns: string[] = [
    'customerName',
    'sourcePartnerName',
    // 'sourcePartnerTenantId',
    // 'partnerOnRecord',
    // 'customerTenantId',
    // 'customerEmailId',
    'azureSubscription',
    'azureReservation',
    'azureSavingsPlan',
    'onlineServicesNCE',
    'ignoreEligibilityCheck',
    'status',
  ];
  public displayedColumns: string[] = [
    'tenantDescription',
    'stockCode',
    'offerDescription',
    'quantity',
    'coterm',
    'status',
    'action'
  ];
  public inProgressColumns: string[] = [
    'tenantDescription',
    'stockCode',
    'offerDescription',
    'quantity',
    'coterm',
    'status'
  ];
  public archiveColumns: string[] = [
    'tenantDescription',
    'stockCode',
    'offerDescription',
    'quantity',
    'coterm',
    'status',
    'manage'
  ];
  constructor(
    private router: Router,
    private fileService: FileService,
    private authService: AuthService,
    private manageService: ManageService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.authService.getLoginInfo()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: CurrentUserModel) => {
          this.currentUserModel = res;

          if (!res.hasPurchaseAccess && res.hasAdminAccess) {
            this.disableUpload = true;
            this.tooltipUpload = 'Requires Purchasing Permissions'
          }
          else if (res.hasPurchaseAccess && !res.hasAdminAccess) {
            this.disableUpload = true;
            this.tooltipUpload = 'Requires Admin Permissions'
          } else if (!res.hasPurchaseAccess && !res.hasAdminAccess) {
            this.disableUpload = true;
            this.tooltipUpload = 'Requires Admin and Purchasing Permissions'
          }
        },
        (error: any) => {
          console.info(error);
        }
      );
    $('#levelOne').animate({ scrollLeft: 250 }, 400);
    this.manageService.GetBulkOrderData("Import Bulk Orders").subscribe((res: any) => {
      this.loadContent = true;
      this.resultTableDataSrc = res;
    }, (error: any) => {
      this.commonService.implementToast(error?.responseMessage, 'Error');
    });
  }

  downloadInstructionFile(): void {
    this.loadContent = false;
    this.fileService.saveFile('New Bulk Order Creation Feature.pdf').subscribe(res => {
      this.fileService.saveAsExcelFile(res, 'New Bulk Order Creation Feature.pdf');
      this.loadContent = true;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  downloadSampleFile(): void {
    this.loadContent = false;
    this.fileService.saveFile('CSPTransfer_Template.xlsx').subscribe(res => {
      this.fileService.saveAsExcelFile(res, 'CSPTransfer_Template.xlsx');
      this.loadContent = true;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  drop(ev) {
    this.loadContent = false;

    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();

    if (ev.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      [...ev.dataTransfer.items].forEach((item, i) => {
        // If dropped items aren't files, reject them
        if (item.kind === "file") {
          const file = item.getAsFile();
          this.file = file
          this.fileName = this.file.name;
          this.resultTableDataSrc = [];
        }
      });
    }
    this.loadContent = true;
  }

  onSelectFile(event): void {
    this.loadContent = false;
    this.file = event.target.files[0];
    this.fileName = this.file?.name;
    //this.resultTableDataSrc = [];
    this.loadContent = true;
  }

  close() {
    this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/CSP');
    $('#levelOne').animate({ scrollLeft: 0 }, 400);
  }

  allowDrop(ev) {
    ev.preventDefault();
  }

  onPreviewTransfer(): void {
    this.loadContent = false;
    const formData = new FormData();
    formData.append(this.file.name, this.file);
    this.manageService
      .validateBulkTransfer(formData)
      .subscribe((res: any) => {
        this.loadContent = true;
        this.resultTableDataSrc = res;

        this.resultTableDataSrc.forEach((r) => {

          if (r.status == 'Validated') {
            r.statusColour = 'green'
          } else if (r.status.toLowerCase().includes('invalid')) {
            r.statusColour = 'red'
          }

        })

      }, (error: any) => {
        this.commonService.implementToast(error?.responseMessage, 'Error');
      });
  }

  public bulkCSPTransferActions() {
    this.loadContent = false;
    this.manageService
      .BulkCSPTransferActions(this.resultTableDataSrc)
      .subscribe((res: any) => {
        this.loadContent = true;

        this.resultTableDataSrc.forEach((r, i) => {

          if (res[i]?.status?.toLocaleLowerCase().includes('error') || res[i]?.status?.toLocaleLowerCase().includes('invalid')) {
            r.status = res[i]?.status
            r.statusColour = 'red'
          } else {
            r.status = 'Validated'
            r.statusColour = 'green'
          }

        })
      }, (error: any) => {
        this.commonService.implementToast(error, 'Error');
      });
  }

  isAllValidated(): Boolean {
    if (!this.resultTableDataSrc || this.resultTableDataSrc.length === 0) {
      return false; // Disable if no data is present
    }
    return this.resultTableDataSrc.every(row => row.status === 'Validated');
  }

  clearPreviewTransfer() {
    this.file = null;
    this.fileName = null;
    this.resultTableDataSrc = [];
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  actionCreateRemoveAll(action) {
    this.dataList = [];
    this.loadContent = false;
    this.resultTableDataSrc.forEach(r => {
      this.dataList.push(r.rowId);
    })

    this.manageService
      .actionCreateRemoveRetry(this.dataList, action)
      .subscribe((res: ApiResponse) => {
        if (res.status === true) {
          this.manageService.GetBulkOrderData("Import Bulk Orders").subscribe((res: any) => {
            this.loadContent = true;
            this.resultTableDataSrc = res;
          });
        } else {
          this.commonService.implementToast(res.responseMessage, "Error");
        }

      }, (error: any) => {
        this.commonService.implementToast(error?.responseMessage, 'Error');
      });
  }

  actionCreateRemoveRetry(rowId: number, action: string) {
    this.dataList = [];
    this.loadContent = false;
    this.dataList.push(rowId);
    this.manageService
      .actionCreateRemoveRetry(this.dataList, action)
      .subscribe((res: ApiResponse) => {
        if (res.status === true) {
          this.manageService.GetBulkOrderData("Import Bulk Orders").subscribe((res: any) => {
            this.loadContent = true;
            this.resultTableDataSrc = res;
          });

        } else {
          this.commonService.implementToast(res.responseMessage, "Error");
        }

      }, (error: any) => {
        this.commonService.implementToast(error?.responseMessage, 'Error');
      });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  myTabSelectedTabChange(event: MatTabChangeEvent) {
    const tabName = event.tab.textLabel;
    this.manageService.GetBulkOrderData(tabName).subscribe((res: any) => {
      this.loadContent = true;
      this.resultTableDataSrc = res;
    }, (error: any) => {
      this.commonService.implementToast(error?.responseMessage, 'Error');
    });

  }

  public navToTenantDetailPage(tenantId: string): void {
    this.router.navigateByUrl(
      this.router.createUrlTree(
        [`/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/${tenantId}`], { queryParamsHandling: 'preserve' }
      )
    );
  }
  public navtoToManageSubscription(tenantId: string, subscriptionId: string): void {
    this.router.navigateByUrl(
      this.router.createUrlTree(
        [`/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/${tenantId}/ManageLicenseSubscriotion/SubscriptionDetails;sub=${subscriptionId}`], { queryParamsHandling: 'preserve' }

      )
    );
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}